export const environment = {
  production: true, // Change to true to enable production optimizations
  environmentName: 'develop',
  apiUrl: 'https://fc-back-eybmg6b4bjcahjdx.westeurope-01.azurewebsites.net/api',
  //apiUrl: 'https://fc-back-dev.azurewebsites.net/api',
  //production settings 
  //apiUrl: 'https://app-cnnc-api-p1.azurewebsites.net/api',
  loggingEnabled: true,
  debugMode: false, // Set to false to reduce bundle size
  atredirectUrl: "https://hcp-at.ferrer.com",
  allowedOrigins: [
    'https://ferrerconnect-f7bghre5czhycpg6.westeurope-01.azurewebsites.net',
    'https://fc-front-e2dee3hzhjf5hycj.westeurope-01.azurewebsites.net',
    'https://fc-front-dev.azurewebsites.net',
    'https://ferrer-connect-front-hfaxbgf4e0gbheeb.westeurope-01.azurewebsites.net',
    'https://app-cnnc-front-p1.azurewebsites.net',
    'https://connect.ferrer.com',
    'https://connectdev.ferrer.com',
  ],
  mockApi: {
    delay: 0,
    timing: 0
  }
};
